import { InfoCardProps } from '@rsa-digital/evo-shared-components/components/InfoCard';
import React from 'react';
import { Container, StyledInfoCard, Token } from './styles';

type InfoCardwithTokenProps = InfoCardProps & {
  token?: string;
};

const InfoCardWithToken: React.FC<InfoCardwithTokenProps> = ({
  token,
  headerIcon,
  heading,
  body,
  primaryCta,
  secondaryCta,
  image,
  logo,
  displayBackground,
  alignLeft,
  link,
  ...props
}) => {
  return (
    <Container>
      {!!token && (
        <Token data-testid="token">
          <p>{token}</p>
        </Token>
      )}
      <StyledInfoCard
        hasToken={!!token}
        headerIcon={headerIcon}
        heading={heading}
        body={body}
        primaryCta={primaryCta}
        secondaryCta={secondaryCta}
        image={image}
        logo={logo}
        displayBackground={displayBackground}
        alignLeft={alignLeft}
        link={link}
        {...props}
      />
    </Container>
  );
};

export default InfoCardWithToken;
